import { render, staticRenderFns } from "./UserStatisticsWeightDialog.vue?vue&type=template&id=84823466&scoped=true"
import script from "./UserStatisticsWeightDialog.vue?vue&type=script&lang=js"
export * from "./UserStatisticsWeightDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84823466",
  null
  
)

export default component.exports